import { useEffect, useState } from "react";
import { Card, CardContent, Container, Grid } from "@material-ui/core";
import { IsMobile900, IsMobile } from "utils/is-mobile";
import FilterCard from "components/_refactor/filter-card";
import HeaderClientes from "components/_refactor/headers/clients";
import StructureFields from "components/_refactor/fields/structure";
import PeriodField from "components/_refactor/fields/period-field";
import BigNumberCard from "components/_refactor/card/big-number";
import TablePainelEntrega from "./components/table-painel-entrega";
import Api from "lib/api/httpRequestHelper";
import useSnackbar from "components/Alerts/Snackbar/useSnackbar";
import UtilsFncs from "utils/UtilsFncs";
import LoadingData from "components/Loading/LoadingData";
import MaskAndValid from "utils/maskAndValid";
import InputText from "components/_refactor/text/input";
import DialogOcorrenciasTransporte from "./components/dialog-ocorrencias-transporte";
import moment from "moment";

const dataHoje = new Date().toISOString().slice(0, 10);

export default function PainelEntrega() {
  const [structureFilters, setStructureFilters] = useState({});
  const [periodo, setPeriodo] = useState("30");
  const [periodoInicial, setPeriodoInicial] = useState(dataHoje);
  const [periodoFinal, setPeriodoFinal] = useState(dataHoje);
  const [clearFilters, setClearFilters] = useState(false);
  const [totalRegisters, setTotalRegisters] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [currentSizePerPage, setCurrentSizePerPage] = useState(25);

  const [ocorrenciasNF, setOcorrenciasNF] = useState(null);
  const [data, setData] = useState();
  const [cardsData, setCardsData] = useState({
    emandamento: "-",
    entregue: "-",
    ematraso: "-",
  });

  const [isLoading, setIsLoading] = useState(false);
  const [loadingCards, setLoadingCards] = useState(false);
  const [structureLoading, setStructureLoading] = useState([]);
  const snackbar = useSnackbar();

  const [cnpj, setCnpj] = useState("");
  const isValidCnpj = cnpj ? MaskAndValid.validateCNPJ(cnpj) : false;
  const cnpjUnmasked = cnpj?.replace(/[^\d]+/g, "");

  const [notaFiscal, setNotaFiscal] = useState("");
  const [numeroPedido, setNumeroPedido] = useState("");

  const notaFiscalTrimmed = (notaFiscal || "").trim();
  const numeroPedidoTrimmed = (numeroPedido || "").trim();
  const idLojaStr =
    structureFilters && typeof structureFilters.idLoja === "string"
      ? structureFilters.idLoja.trim()
      : "";
  const hasLojaSelection =
    Boolean(idLojaStr) ||
    Boolean(
      structureFilters?.idLojaUnica !== undefined &&
      structureFilters?.idLojaUnica !== null &&
      `${structureFilters.idLojaUnica}`.trim() !== "",
    );
  const hasMinimumSearchCriteria =
    Boolean(structureFilters?.idGrupoEconomico) ||
    hasLojaSelection ||
    isValidCnpj ||
    Boolean(notaFiscalTrimmed) ||
    Boolean(numeroPedidoTrimmed);

  const isMobile = IsMobile();
  const isMobile900 = IsMobile900();

  const itemSM = isMobile ? 12 : 4;
  const itemXS = isMobile ? 12 : isMobile900 ? 6 : 3;

  const formatDateForApi = (date) => {
    if (!date) return "";
    if (/^\d{4}-\d{2}-\d{2}$/.test(date)) {
      return date;
    }
    if (/^\d{2}-\d{2}-\d{4}$/.test(date)) {
      const parts = date.split("-");
      return `${parts[2]}-${parts[0]}-${parts[1]}`;
    }
    const momentDate = moment(date, ["MM-DD-YYYY", "DD-MM-YYYY", "YYYY-MM-DD"]);
    if (momentDate.isValid()) {
      return momentDate.format("YYYY-MM-DD");
    }
    return date;
  };

  const handleSearchDelivery = async ({
    page = 0,
    sizePerPage = 25,
    status = "",
  }) => {
    if (!hasMinimumSearchCriteria) {
      snackbar.showMessage(
        "Informe pelo menos um: Grupo Econômico, Loja, CNPJ válido, Número da Nota Fiscal ou Número do Pedido.",
        { severity: "error" },
      );
      return;
    }

    setIsLoading(true);
    try {
      const formattedInitialDate = formatDateForApi(periodoInicial);
      const formattedFinalDate = formatDateForApi(periodoFinal);

      const queryParams =
        "?page=" +
        page +
        "&pageSize=" +
        sizePerPage +
        "&status=" +
        status +
        "&dtIni=" +
        formattedInitialDate +
        "&dtFim=" +
        formattedFinalDate +
        (notaFiscalTrimmed ? `&nrNf=${notaFiscalTrimmed}` : "") +
        (numeroPedidoTrimmed ? `&nrPedido=${numeroPedidoTrimmed}` : "");

      const paramsWithCnpj = {};

      if (structureFilters) {
        Object.keys(structureFilters).forEach((key) => {
          const value = structureFilters[key];
          if (value !== undefined && value !== null && value !== "") {
            paramsWithCnpj[key] = value;
          }
        });
      }

      if (isValidCnpj) {
        paramsWithCnpj.cnpj = cnpjUnmasked;
      }

      const response = await Api.get(
        "list-order",
        "omnireport",
        UtilsFncs.RestParamsComposer(paramsWithCnpj, queryParams),
        true,
      );
      setData(
        (response?.Result?.ListPedidos || []).map((item, idx) => ({
          ...item,
          IdDelivery: item.IdDelivery ?? idx,
        })),
      );
      setCurrentPage(page);
      setCurrentSizePerPage(sizePerPage);
      setTotalRegisters(response?.Result?.TotalRegistros || 0);
    } catch (error) {
      snackbar.showMessage(
        "Erro ao buscar dados de entrega: " + error.message,
        {
          severity: "error",
        },
      );
      setData([]);
    } finally {
      setIsLoading(false);
    }
  };

  const handleAllTotals = async () => {
    if (!hasMinimumSearchCriteria) {
      setCardsData({
        emandamento: "-",
        entregue: "-",
        ematraso: "-",
      });
      return;
    }

    setLoadingCards(true);
    try {
      const formattedInitialDate = formatDateForApi(periodoInicial);
      const formattedFinalDate = formatDateForApi(periodoFinal);

      const queryParams =
        "?status=TODOS&dtIni=" +
        formattedInitialDate +
        "&dtFim=" +
        formattedFinalDate +
        (notaFiscalTrimmed ? `&nrNf=${notaFiscalTrimmed}` : "") +
        (numeroPedidoTrimmed ? `&nrPedido=${numeroPedidoTrimmed}` : "");

      const paramsWithCnpj = {};

      if (structureFilters) {
        Object.keys(structureFilters).forEach((key) => {
          const value = structureFilters[key];
          if (value !== undefined && value !== null && value !== "") {
            paramsWithCnpj[key] = value;
          }
        });
      }

      if (isValidCnpj) {
        paramsWithCnpj.cnpj = cnpjUnmasked;
      }

      const response = await Api.get(
        "list-order-total",
        "omnireport",
        UtilsFncs.RestParamsComposer(paramsWithCnpj, queryParams),
        true,
      );

      const r = response?.Result;
      setCardsData({
        emandamento:
          r != null && typeof r.TotalAndamento === "number"
            ? r.TotalAndamento
            : "-",
        entregue:
          r != null && typeof r.TotalEntrege === "number"
            ? r.TotalEntrege
            : "-",
        ematraso:
          r != null && typeof r.TotalAtraso === "number" ? r.TotalAtraso : "-",
      });
    } catch (error) {
      console.error("Erro ao buscar totais:", error);
      snackbar.error("Erro ao buscar totais: " + error.message);
      setCardsData({
        emandamento: "-",
        entregue: "-",
        ematraso: "-",
      });
    } finally {
      setLoadingCards(false);
    }
  };

  const handleOccurencesData = async (row) => {
    try {
      const response = await Api.get(
        "tracking-occurrences",
        "sellinorder",
        "?chaveNF=" + row.ChaveNf,
        true,
      );

      if (!response || response.Result?.Ocorrencias?.length === 0) {
        snackbar.showMessage(
          "Não foram encontradas ocorrências de entrega para essa nota.",
          {
            severity: "info",
          },
        );
      } else {
        setOcorrenciasNF({ ...row, ...response.Result });
      }
    } catch (error) {
      snackbar.showMessage(error, {
        severity: "error",
      });
      console.log(error);
    }
  };

  const handleClearFilters = () => {
    setClearFilters(true);
    setPeriodo("30");
    setPeriodoInicial(dataHoje);
    setPeriodoFinal(dataHoje);
    setCnpj("");
    setNotaFiscal("");
    setNumeroPedido("");
  };

  const CARDS_INFO = [
    {
      title: "Entregas em Andamento",
      value: cardsData.emandamento,
      loading: loadingCards,
      legend: "Filtrar por entregas em andamento",
      onClick: () => {
        handleSearchDelivery({
          page: 0,
          sizePerPage: currentSizePerPage,
          status: "EMANDAMENTO",
        });
      },
    },
    {
      title: "Entregas Realizadas",
      value: cardsData.entregue,
      loading: loadingCards,
      legend: "Filtrar por entregas realizadas",
      onClick: () => {
        handleSearchDelivery({
          page: 0,
          sizePerPage: currentSizePerPage,
          status: "ENTREGUE",
        });
      },
    },
    {
      title: "Entregas Atrasadas",
      value: cardsData.ematraso,
      loading: loadingCards,
      legend: "Filtrar por entregas atrasadas",
      onClick: () => {
        handleSearchDelivery({
          page: 0,
          sizePerPage: currentSizePerPage,
          status: "EMATRASO",
        });
      },
    },
  ];

  const handleSearch = () => {
    setClearFilters(false);
    handleSearchDelivery({
      page: currentPage,
      sizePerPage: currentSizePerPage,
      status: "",
    });
    handleAllTotals();
  };

  useEffect(() => {
    if (hasMinimumSearchCriteria) {
      handleSearch();
    }
  }, []);

  return (
    <>
      <HeaderClientes
        section="Acompanhamento de Entrega"
        subsection="Clientes"
      />
      <Container maxWidth={false} style={{ marginTop: "-4.5rem" }}>
        <FilterCard
          handleSearch={handleSearch}
          disabled={
            isLoading ||
            structureLoading.length > 0 ||
            !hasMinimumSearchCriteria
          }
          searching={isLoading}
          handleClearFilters={handleClearFilters}
        >
          <StructureFields
            onStructureFieldsChange={setStructureFilters}
            disableAll={isLoading || structureLoading.length > 0}
            onStructureFieldsLoad={setStructureLoading}
            hideFields={["brand", "channel", "representative"]}
            clearFilters={clearFilters}
            handleSearch={handleSearch}
          />
          <Grid item xs={12} sm={4} md={4}>
            <InputText
              label="CNPJ"
              value={cnpj}
              onChange={(e) => {
                setCnpj(MaskAndValid.maskCNPJ(e.target.value));
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  handleSearch();
                }
              }}
              disabled={isLoading}
              placeholder="00.000.000/0000-00"
            />
          </Grid>
          <Grid item xs={12} sm={4} md={4}>
            <InputText
              label="Nota Fiscal"
              value={notaFiscal}
              onChange={(e) => {
                setNotaFiscal(e.target.value);
              }}
              disabled={isLoading}
              type="number"
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  handleSearch();
                }
              }}
            />
          </Grid>
          <Grid item xs={12} sm={4} md={4}>
            <InputText
              label="Número do Pedido"
              value={numeroPedido}
              onChange={(e) => {
                setNumeroPedido(e.target.value);
              }}
              disabled={isLoading}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  handleSearch();
                }
              }}
            />
          </Grid>
          <Grid item xs={periodo === "Outros" ? "12" : itemXS}>
            <PeriodField
              label="Período"
              value={{ value: periodo, label: `Últimos ${periodo} dias` }}
              onChange={(option) => setPeriodo(option.value)}
              initialDate={periodoInicial}
              finalDate={periodoFinal}
              setInitialDate={setPeriodoInicial}
              setFinalDate={setPeriodoFinal}
              disabled={isLoading}
              required={false}
            />
          </Grid>
        </FilterCard>

        <Card>
          <CardContent>
            <Grid container spacing={2}>
              {CARDS_INFO.map((card, index) => (
                <Grid item xs={itemSM} key={index}>
                  <BigNumberCard
                    title={card.title}
                    value={card.value}
                    loading={card.loading}
                    legend={card.legend}
                    onClick={card.onClick}
                  />
                </Grid>
              ))}
            </Grid>
          </CardContent>
        </Card>

        <Grid item xs={12}>
          {isLoading ? (
            <LoadingData searching={isLoading} label="Buscando dados..." />
          ) : (
            <TablePainelEntrega
              data={data}
              totalRegistros={totalRegisters}
              currentPage={currentPage}
              currentSizePerPage={currentSizePerPage}
              handleSelectRow={handleOccurencesData}
              onTableChange={(type, { page, sizePerPage }) => {
                handleSearchDelivery({ page: page - 1, sizePerPage });
              }}
            />
          )}
        </Grid>
      </Container>

      {ocorrenciasNF && (
        <DialogOcorrenciasTransporte
          open={!!ocorrenciasNF}
          onClose={() => setOcorrenciasNF(null)}
          chaveNf={ocorrenciasNF?.ChaveNf}
          numero={ocorrenciasNF?.Numero}
          serie={ocorrenciasNF?.Serie}
        />
      )}
    </>
  );
}
